export default __webpack_public_path__ + "static/media/in-review-2021-logo.6dc319f8.png";